import { appConstants } from "../../constants/appconstants";
import { getApiCall, postApiCall,deleteApiCall, patchApiCall } from "../../utils/ApiMethods";
import { localStoreKeys } from "../../constants/localStoreKeys";
import { setKeyValue } from "../reducer/localDataSlice";

const FetchAllNotificationAction = () => {
    return async function (dispatch) {
        const data = await getApiCall(`${appConstants.BASE_URL}/admin-notification/get-notifications`);
        const values = {
            "data": data || []
        }
        var resData = Object.assign({ type: 'SUCCESS_ALL_NOTIFICATION_ACTION' }, values);
        dispatch(resData);
    };
};

const FetchSaveNotificationAction = (requestObj) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/admin-notification/save-notification`, requestObj);
        var resData = Object.assign({ type: 'SUCCESS_SAVE_NOTIFICATION_ACTION' }, data);
        dispatch(resData);
    };
}

const FetchDeleteNotificationAction = (requestObj) => {
    return async function (dispatch) {
        const data = await deleteApiCall(`${appConstants.BASE_URL}/admin-notification/delete-notification`, requestObj);
        var resData = Object.assign({ type: 'SUCCESS_DELETE_NOTIFICATION_ACTION' }, data);
        dispatch(resData);
    };
}
const FetchPublishNotificationAction = (requestObj) => {
    return async function (dispatch) {
        const data = await patchApiCall(`${appConstants.BASE_URL}/admin-notification/publish-notification`, requestObj);
        var resData = Object.assign({ type: 'SUCCESS_DELETE_NOTIFICATION_ACTION' }, data);
        dispatch(resData);
    };
}

export {
    FetchAllNotificationAction,
    FetchSaveNotificationAction,
    FetchDeleteNotificationAction,
    FetchPublishNotificationAction
}